import { Button, Collapse } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import cx from 'classnames';
import React, { useState } from 'react';

import { RichTextWithEmbeds } from 'components/RichText';

import { Typography } from '../Typography';
import { DescriptionIcon } from './DescriptionIcon';

const useStyles = makeStyles(theme => ({
  card: {
    borderRadius: '15px',
    boxShadow: 'rgba(0, 0, 0, 0.25) 0px 2.30916px 4.61832px',
    color: theme.palette.common.gray600,
    padding: theme.spacing(1.5),
    paddingBottom: 0,
    [theme.breakpoints.up('md')]: {
      padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
      paddingBottom: 0,
    },
  },
  title: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  icon: {
    color: theme.palette.common.gray800,
  },
  button: {
    width: '100%',
    borderRadius: '5px',
    margin: `${theme.spacing(1.5)}px 0`,
    [theme.breakpoints.up('md')]: {
      margin: `${theme.spacing(2)}px 0`,
    },
  },
  description: {
    maxHeight: '284px',
    overflow: 'hidden',
    '&.fullContent': {
      maxHeight: '100%',
    },
    [theme.breakpoints.up('md')]: {
      maxHeight: '272px',
    },
  },
}));

export interface JobDescriptionProps {
  title: string | JSX.Element;
  body: string;
  isExpandJobDescription: boolean;
}

export const ReachJobDescription: React.VFC<JobDescriptionProps> = ({
  title,
  body,
  isExpandJobDescription,
}) => {
  const [collapsed, setCollapsed] = useState(isExpandJobDescription);
  const styles = useStyles();

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Collapse in={collapsed} collapsedHeight={400} className={styles.card}>
      <div className={styles.title}>
        <DescriptionIcon className={styles.icon} />
        <Typography variant="headingSM">{title}</Typography>
      </div>
      <RichTextWithEmbeds
        text={body}
        className={cx(styles.description, { fullContent: collapsed })}
      />
      <Button
        variant="outlined"
        onClick={toggleCollapse}
        className={styles.button}
      >
        {!collapsed ? 'Read more' : 'Read less'}
      </Button>
    </Collapse>
  );
};
